import takahashiImage from '../file/dr/drsfarm-takahashi.webp';
import kodamaImage from '../file/dr/drsfarm-kodama.webp';
import doumoriImage from '../file/dr/drsfarm-doumori.webp';
import nagaiImage from '../file/dr/drsfarm-nagai.jpg';
import kimuraImage from '../file/dr/drsfarm-kimura.webp';
import hottaImage from '../file/dr/drsfarm-hotta.webp';
import ozekiImage from '../file/dr/drsfarm-ozeki.webp';

export const featuredDoctors = [
  {
    id: 'nagai-shinse',
    slug: 'nagai-shinse',
    name: '永井 伸瀬 先生',
    title: '愛知県 歯科医',
    specialty: '歯科 / 予防医療',
    profileImageUrl: nagaiImage,
    imagePosition: 'center 22%',
    youtubeUrl: 'https://www.youtube.com/watch?v=59ToOAgr_Rs',
    message: '自身の病気の経験をきっかけに、食の質と地域で支える食の大切さを伝えるためDrs.Farmに参加しています。',
    profileLong: [
      '愛知県で歯科医として診療を行う永井伸瀬先生は、自身が人間ドックで初期の大腸がんを経験したことをきっかけに、「体に入るもの」、特に食の質について深く考えるようになりました。',
      'この経験を通じて、自分自身だけでなく、患者さんや家族、地域の人々にも食の大切さを伝えていきたいという思いを強く持つようになりました。',
      'Drs.Farmへの参加は、無農薬農家とのつながりを知ったことがきっかけです。安心できる食材を身近に届ける取り組みに共感し、歯科医療の立場からも健康を支える活動に関わっています。',
      'また、現代は食材価格の高騰や外部への依存が進む中、「自分たちの食を自分たちで支える」という小さなコミュニティの重要性を提唱しています。',
      '無農薬や化学肥料不使用といった理想を追求するだけでなく、地域の中で食を生産し、共有し、安心して楽しめる環境を広げること。',
      'Drs.Farmを通じて、食の自立と安心できる食生活の基盤づくりに貢献していきたいと考えています。',
    ],
    visibility: 'public',
    displayOrder: 4,
  },
  {
    id: 'hotta-yoshihiro',
    slug: 'hotta-yoshihiro',
    name: '堀田由浩',
    title: '統合医療',
    specialty: '原因からなおす統合医療 / 再生医療を用いたガン治療 / 漢方 / 心理 / 感情解放 / 分子栄養医学',
    clinic: 'Kibo Clinic',
    clinicUrl: 'https://kibo.clinic/',
    profileImageUrl: hottaImage,
    youtubeUrl: 'https://youtu.be/TVuhJeLVINA',
    imagePosition: 'center center',
    message: '外科医、形成外科を経て、統合医療的視点から病の原因を心と身体とスピリットの面から探し、解決をサポートしています。',
    profileLong: [
      '外科医，形成外科を経て統合医療的視点から病の原因を心と身体とスピリットの面から探して解決することをサポートしております。',
    ],
    clinicDescription: [
      '名古屋駅から徒歩7分、再生医療を用いたがん免疫細胞療法を中心に心理的ケア、漢方による臓器バランス調整、分子栄養医学による分子レベルでの栄養改善、食養生、人生哲学までとことん患者さんの人生と向き合うカウンセリングを実践しています。',
    ],
    visibility: 'public',
    displayOrder: 5,
  },
  {
    id: 'kimura-yoshihisa',
    slug: 'kimura-yoshihisa',
    name: '木村仁志',
    title: '内科',
    specialty: '内科 / 腎臓内科 / 糖尿病内科',
    clinic: '木村内科小児科クリニック',
    clinicUrl: 'https://kimuranaikashounika.jp/',
    profileImageUrl: kimuraImage,
    youtubeUrl: 'https://youtu.be/nRySSaJliwc',
    imagePosition: 'center center',
    message: '地域に根ざした診療の中で、「日々の食事」と「食育」の大切さを伝え、食と健康をつなぐ新しい取り組みに挑戦しています。',
    profileLong: [
      '小児科医である母の背中を見て育ち、医療を身近に感じてきました。',
      '私自身、学生時代に目（網膜剥離）や肺（自然気胸）の手術を経験した際、医療従事者の献身的な姿勢と健康の尊さを身をもって知り、医師の道を志しました。',
      '現在は、育てていただいた地域に恩返しをしたいという想いから、10年前より実家のクリニックにて母と共に日々の診療に邁進しております。',
    ],
    clinicDescription: [
      '当院には内科として多くの生活習慣病の患者様が来院されます。日々の診療を通じ痛感するのは、薬以上に「日々の食事」がいかに重要か、ということです。また、その習慣の土台となる子供たちへの「食育」も、地域の未来を守るために欠かせない役割だと確信しています。',
      '私たちは単なる診察にとどまらず、管理栄養士による丁寧な食事指導や栄養外来、さらには委託農地での無農薬野菜の収穫体験など、食と健康をつなぐ新しい試みに日々挑戦しています。',
      '「食べたものが、体をつくる」。その当たり前で大切なことを、地域の皆様と共に楽しみながら実践していける場所でありたいと願っています。',
    ],
    visibility: 'public',
    displayOrder: 6,
  },
  {
    id: 'ozeki-akitsugu',
    slug: 'ozeki-akitsugu',
    name: '小関晶嗣',
    title: '愛知県江南市 おぜき耳鼻咽喉科',
    specialty: '耳鼻咽喉科',
    clinic: 'おぜき耳鼻咽喉科',
    clinicUrl: 'https://www.ozeki-ent.com/',
    profileImageUrl: ozekiImage,
    imagePosition: 'center center',
    youtubeUrl: 'https://youtu.be/MuL5fqA4CmM',
    message: '名古屋市立大学や豊田厚生連での勤務を経て、愛知県江南市でおぜき耳鼻咽喉科を開院し、耳鼻咽喉科全般の診療に取り組んでいます。',
    profileLong: [
      'H3年名古屋市立大学医学部卒業、研修後、2年間米国ミネソタ州立大学にで研究後、名古屋市立大学医学部勤務、豊田厚生連勤務後、H20年愛知県江南市におぜき耳鼻咽喉科を開院、現在に至る。',
    ],
    clinicDescription: [
      '江南市の滝高校のすぐ東市に位置し18年になります。',
      '専門は耳鼻咽喉科全般です。',
      '病状について納得していただける説明を心がけております。宜しくお願い致します。',
    ],
    visibility: 'public',
    displayOrder: 7,
  },
  {
    id: 'doumori-takemasa',
    slug: 'doumori-takemasa',
    name: '堂森丈正',
    title: '愛知県長久手市 堂森グリーンロードクリニック',
    specialty: '内科 / 循環器内科',
    clinic: '堂森グリーンロードクリニック',
    clinicUrl: 'http://doumori-grc.main.jp/',
    profileImageUrl: doumoriImage,
    imagePosition: 'center 20%',
    message: '「早期発見・早期治療」を礎にしながら、病気の本質的な予防には食事と運動が重要だと考え、食を支える農業の大切さを伝えるためにDrs.Farmへ参加しています。',
    profileLong: [
      '長久手市にて開業しております、堂森と申します。',
      '当初は父と同じ消化器内科を志しましたが、その後、心臓や血管を専門とする循環器内科の道へ進みました。',
      '医師になって以来、「早期発見・早期治療」を信念に診療を行ってきました。消化器領域では内視鏡によるがんの早期発見、循環器領域では血管が詰まる前の狭心症の段階での診断と治療に力を注いできました。',
      'しかし診療を重ねる中で、病気の本質的な予防には、生活習慣の改善、すなわち「食事」と「運動」が何より重要であると強く感じるようになりました。',
      'そして、その「食」の根幹を支えているのが農業に携わる方々の存在です。安心・安全な作物を届けたいという想いに共感し、その一助となりたいと考え、ドクターズファームの理念に賛同し参加いたしました。',
      '健康の源は「食」にあります。',
      'この大切なテーマを皆さまと共に学び、広く社会に伝え、未来の子どもたちへとつないでいければと願っております。',
    ],
    clinicDescription: [
      '近年、生活習慣の欧米化や高齢化に伴い、動脈硬化を背景とした脳梗塞や心筋梗塞の患者様は増加しています。こうした病気において最も大切なのは、発症してからの治療ではなく、「発症する前の予防と改善」です。',
      'すなわち、生活習慣病やメタボリックシンドロームの段階で適切に介入し、健康へ導く医療がこれまで以上に求められています。',
      '当クリニックではお薬だけでなく、患者様一人ひとりの生活習慣をトータルに見つめ、すこやかな健康生活を応援し、予防を第一に心がけた医療を目指しています。',
    ],
    visibility: 'public',
    displayOrder: 3,
  },
  {
    id: 'kodama-masataka',
    slug: 'kodama-masataka',
    name: '児玉将隆',
    title: '愛知県瀬戸市 こだま耳鼻科クリニック 院長',
    specialty: '耳鼻咽喉科 / アレルギー科 / 潜水医学 / 高山病',
    clinic: 'こだま耳鼻科クリニック',
    clinicUrl: 'https://kodama-ent.jp/',
    profileImageUrl: kodamaImage,
    imagePosition: 'center 18%',
    youtubeUrl: 'https://www.youtube.com/watch?v=u7cEQVoTyP0',
    message: '耳鼻咽喉科医としての経験と、自身の花粉症の体験を通じて、食とアレルギーの深い関係を伝え、健康的な食生活の大切さを広めたいと考えています。',
    profileLong: [
      '耳鼻咽喉科医として35年以上、診療に携わってまいりました。',
      '私は10代の頃から花粉症に悩まされてきました。まだ花粉症という概念が一般的でなかった時代、鼻づまりで夜も眠れず、激しい目のかゆみにも苦しみ、日常生活のパフォーマンスは大きく低下していました。',
      'このつらい経験が、「患者さんを少しでも楽にしてあげたい」という想いにつながり、医師の道を選びました。',
      '近年、食とアレルギーは密接に関係していることが広く知られるようになってきています。私は、日々の食事を見直すことが、症状の改善や予防につながる重要な要素だと考えています。',
      '少しでも健康的な食生活を広め、皆さまがより健やかな毎日を送れるよう、その一助となりたいという想いから、この活動に参加しております。',
    ],
    clinicDescription: [
      '地域の皆さまに親しまれお役に立てる医療、皆さまのニーズに的確に応える医療を目指したいと考え、2000年2月、当地にこだま耳鼻科クリニックを開院いたしました。',
      '皆さまに来てよかったと思っていただけるよう、スタッフ全員で治療やサポートをさせていただきます。',
      'ご自身やご家族の体について気になること、困ったことがありましたら、どんなことでもお気軽にご相談ください。',
      'スタッフ一同、明るく元気な空間であり続けたいと願っております。',
    ],
    visibility: 'public',
    displayOrder: 2,
  },
  {
    id: 'takahashi-nobuo',
    slug: 'takahashi-nobuo',
    name: '高橋信雄',
    title: 'Drs.Farm 代表',
    specialty: '糖尿病内科 / 消化器内科',
    clinic: '高橋ファミリークリニック',
    clinicUrl: 'http://tfclinic.org/dcd/',
    profileImageUrl: takahashiImage,
    imagePosition: 'center 18%',
    youtubeUrl: 'https://www.youtube.com/watch?v=yyoqpsW_g_w',
    message: '「食が人をつくる」という確信のもと、医療・食・農業をつなぎ、患者さん主体の医療と地域の健康づくりを追求しています。',
    profileLong: [
      'ドクターズファーム代表の高橋です。',
      '小学生の頃、医学生の家庭教師に憧れたことをきっかけに医師の道を志しました。',
      'しかし臨床の現場に立つ中で、西洋医学だけでは解決できない倦怠感や心の不調に数多く向き合い、強い違和感を抱くようになりました。',
      'その経験から、日本ホリスティック医学協会に所属し、あらゆる治療法を否定せず、「患者さん主体の医療」を追求しています。',
      '私は「食が人をつくる」と確信しています。医療・食・農業は切り離せないものであり、土壌微生物と腸内細菌の関係は非常に似ています。',
      '特定の症状だけに対処するのではなく、全体の調和を整えることこそが、真の健康につながると考えています。',
      '45歳のときに出会った苫米地式マインドコーチングを通じて、「病気も人生も自らが創り、自ら変えていける」という主体的な生き方を伝えています。',
      '笑顔と温かい触れ合いの中で、患者さん一人ひとりが「幸せだ」と感じられる。そんな心が動くコミュニティを地域に根づかせることが、私の理想です。',
      'また、古神道や古武道（合気・太極拳）の実践にも取り組んでいます。',
    ],
    clinicDescription: [
      '「安らぎ」と「癒し」、そして「笑顔」。それが当院の大切にしている医療です。',
      '私たちは糖尿病診療を中心に、患者さん一人ひとりに寄り添うことを何より大切にしています。診察室には医療秘書を配置し、丁寧にお話を伺う時間をしっかり確保しています。',
      'また、「笑いの会」などを通じて、心から元気になれる場づくりにも取り組んでいます（現在は感染症の影響により一時中断中）。',
      '看護師・管理栄養士・臨床検査技師・医療事務など多職種が連携し、糖尿病療養指導士も約10名在籍。さらに、薬剤師とも連携しながら月1回の症例検討を行い、チーム全体で患者さんを支えています。',
      '近年は糖尿病・肥満領域において、保険診療に加え自費診療にも対応し、より幅広い選択肢をご提供しています。',
    ],
    visibility: 'public',
    displayOrder: 1,
  },
];

export function mergeDoctorProfiles(remoteRows = []) {
  const remoteByKey = new Map();
  for (const row of remoteRows) {
    const key = row.slug || row.id;
    remoteByKey.set(key, row);
  }

  const merged = [];
  const usedKeys = new Set();

  for (const base of featuredDoctors) {
    const key = base.slug || base.id;
    const remote = remoteByKey.get(key);
    merged.push({ ...base, ...(remote || {}) });
    usedKeys.add(key);
  }

  for (const row of remoteRows) {
    const key = row.slug || row.id;
    if (usedKeys.has(key)) continue;
    merged.push(row);
  }

  return merged.sort((a, b) => (Number(a.displayOrder ?? 9999) - Number(b.displayOrder ?? 9999)) || String(a.name || '').localeCompare(String(b.name || '')));
}
